






















import { Component, Prop } from 'vue-property-decorator'

import { RowButtonView } from '../../../../../../components'
import NodeMessagePreview from '../../../../../../components/SampleNodeComponents/NodeMessagePreview.vue'
import { SampleNodeMixin } from '../../../../index'
import { EditLastMessageNode } from '../../logic/EditLastMessageNode'

@Component({
  components: {
    RowButtonView,
    NodeMessagePreview
  }
})
export default class SampleEditLastMessageNode extends SampleNodeMixin {
  @Prop() node!: EditLastMessageNode
}
